<template>
  <div>
    Loading...
  </div>
</template>

<script>
import { actionNames } from '../../store'

export default {
  name: 'Callback',
  async mounted () {
    try {
      await this.$store.dispatch(actionNames.HANDLE_AUTH_CALLBACK)
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style scoped>

</style>
